export default __webpack_public_path__ + "static/media/home-small-icon.4bae2aad.svg";